// extracted by mini-css-extract-plugin
module.exports = {"parallax":"Design_parallax__3bRFB","legend":"Design_legend__2vL9i","hero":"Design_hero__1fppL","container":"Design_container__dRVR0","blueprint":"Design_blueprint__2Ma1x"};